import React from "react";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import SupportCaseList from "../components/SupportCases/SupportCaseList";

/**
 * SupportCasesPage: the standalone /support-cases screen.
 *
 * Thin on purpose. The list itself lives in components/SupportCases so the
 * account panel (Sidebar/SidebarData.js) and this page share ONE
 * implementation; this file only adds the page chrome for the deep linkable
 * URL that the order screen and the case detail screen both link to.
 */
const SupportCasesPage = () => (
  <>
    <Navbar />
    <Page>
      <SupportCaseList />
    </Page>
  </>
);

const Page = styled.div`
  max-width: 760px;
  margin: 0 auto;
  padding: calc(var(--lusuku-nav-h, 130px) + 12px) 16px 56px;
  min-height: 60vh;
`;

export default SupportCasesPage;
